interface CompletionRingProps {
  /** 0–100 */
  value: number;
  size?: number;
  label?: string;
}

/** Compact circular progress dial used in the application rail header. */
export function CompletionRing({ value, size = 52, label }: CompletionRingProps) {
  const stroke = 4;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const clamped = Math.max(0, Math.min(100, value));
  const offset = c - (clamped / 100) * c;

  return (
    <div className="flex items-center gap-3">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            fill="none"
            stroke="var(--landing-glass-border)"
            strokeWidth={stroke}
          />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            fill="none"
            stroke="url(#completionGradient)"
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={c}
            strokeDashoffset={offset}
            style={{ transition: "stroke-dashoffset 0.5s cubic-bezier(0.16,1,0.3,1)" }}
          />
          <defs>
            <linearGradient id="completionGradient" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="var(--acc2)" />
              <stop offset="100%" stopColor="var(--pos)" />
            </linearGradient>
          </defs>
        </svg>
        <span
          className="absolute inset-0 flex items-center justify-center text-[11px] font-bold tabular-nums"
          style={{ color: "var(--landing-text)" }}
        >
          {clamped}%
        </span>
      </div>
      {label && (
        <div>
          <p className="text-sm font-semibold" style={{ color: "var(--landing-text)" }}>
            {label}
          </p>
          <p className="text-xs" style={{ color: "var(--landing-text-muted)" }}>
            {clamped === 100 ? "Ready to submit" : "Keep going"}
          </p>
        </div>
      )}
    </div>
  );
}
